import apiClient from "utils/apiClient";

const PRICE_UPDATE_ALL_ENDPOINT = "/api/price/update-all";
const PRICE_UPDATE_ONE_ENDPOINT = "/api/price/update-one";

const isMethodNotAllowed = (err) => err?.response?.status === 405;

/**
 * Triggers a single product price recalculation on the backend.
 *
 * Sends the product ID in req.body.
 */
export async function triggerPriceUpdateOne(productId) {
  const res = await apiClient.post(PRICE_UPDATE_ONE_ENDPOINT, { productId });
  return res.data;
}

/**
 * Triggers a full price recalculation on the backend.
 *
 * We try POST first (most common for "do work" endpoints), then fall back if the
 * server is implemented differently.
 */
export async function triggerPriceUpdateAll() {
  try {
    const res = await apiClient.post(PRICE_UPDATE_ALL_ENDPOINT);
    return res.data;
  } catch (err) {
    if (!isMethodNotAllowed(err)) throw err;
  }

  try {
    const res = await apiClient.put(PRICE_UPDATE_ALL_ENDPOINT);
    return res.data;
  } catch (err) {
    if (!isMethodNotAllowed(err)) throw err;
  }

  const res = await apiClient.get(PRICE_UPDATE_ALL_ENDPOINT);
  return res.data;
}

